const T = require('prop-types');
const { makeActionCreator } = require('../utils/redux-helpers');
const { push: Push } = require('connected-react-router');
const { PROFILE_MANAGEMENT: Types } = require('../action-types');
const ProfileSession = require('services/auth-management/profile-session');
const RoutingTable = require('services/auth-management/routing-table');
const StarterRefresh = require('utils/conversationStarterRefresh');

module.exports = (context) => {

    const api       = context.api.nearpeer;
    const actions   = context.actions;
    const redux     = context.redux.hooks;

    return {
        // PROFILE_MANAGEMENT.UPDATE_USER_PREFERENCES
        updateUserPreferences: makeActionCreator(Types.UPDATE_USER_PREFERENCES, undefined, { // see diff in reducers/data-fetching
            async: api.profileManagement.updateUserPreferences,
            after: ({ dispatch }) => {

                dispatch(actions.dataFetching.fetchPreferences());
            }
        }),
        // PROFILE_MANAGEMENT.UPDATE_PROFILE
        updateProfile: makeActionCreator(Types.UPDATE_PROFILE, undefined, {
            async: api.profileManagement.updateProfile,
            after: ({ dispatch, payload }) => {

                if (payload.result) {
                    dispatch({
                        type: 'DATA_FETCHING/FETCH_CURRENT_USER/SUCCESS',
                        payload: { result: payload.result }
                    });
                }

                if (payload.request?.interests !== undefined || payload.request?.passionInterests !== undefined) {
                    StarterRefresh.notify();
                }

                dispatch(actions.dataFetching.fetchPreferences());
            }
        }),
        // PROFILE_MANAGEMENT.UPDATE_PROFILE_PICTURE
        updateProfilePicture: makeActionCreator(Types.UPDATE_PROFILE_PICTURE, undefined, {
            async: api.profileManagement.updateProfilePicture,
            after: ({ dispatch }) => {

                dispatch(actions.dataFetching.fetchCurrentUser());
            }
        }),
        // PROFILE_MANAGEMENT.CHANGE_USER_PASSWORD
        changePassword: makeActionCreator(Types.CHANGE_USER_PASSWORD, { password: T.string, newPassword: T.string, newPasswordConfirm: T.string, logoutOtherDevices: T.bool }, {
            async: api.passwordManagement.changePassword
        }),
        // PROFILE_MANAGEMENT.JOIN_SCHOOL
        joinSchool: makeActionCreator(Types.JOIN_SCHOOL, { schoolId: T.number }, {
            async: async (payload) => {

                await api.profileManagement.joinSchool(payload);

                await redux.dispatch(actions.dataFetching.fetchCurrentUser());
            }
        }),
        // PROFILE_MANAGEMENT.LEAVE_SCHOOL
        leaveSchool: makeActionCreator(Types.LEAVE_SCHOOL, { schoolId: T.number }, {
            async: async (payload) => {

                await api.profileManagement.leaveSchool(payload);

                await redux.dispatch(actions.dataFetching.fetchCurrentUser());
            }
        }),
        // PROFILE_MANAGEMENT.SWITCH_SCHOOL
        switchSchool: makeActionCreator(Types.SWITCH_SCHOOL, { schoolId: T.number, leaveSchoolIdAfterSwitch: T.number, afterSwitchFunc: T.func, redirect: T.oneOf(Object.values(RoutingTable.REDIRECTS)), target: T.string }, {
            async: ProfileSession.switchSchoolSession
        })
    };
};
